export default __webpack_public_path__ + "audio/76d6e593571dba26bb838cd4fcb5bf0f.mp3";